export default "__VITE_ASSET__Do8U9uUd__"